"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortIconSort = exports.TableSortIconArrowUp = exports.TableSortIconArrowDown = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../Icon/index");
var TableSortIconArrowDown = /*#__PURE__*/(0, _styledComponents.default)(_index.IconArrowDown).withConfig({
  displayName: "TableSortIconArrowDown",
  componentId: "c11n-8-101-0__sc-1lrs09d-0"
})([""]);
exports.TableSortIconArrowDown = TableSortIconArrowDown;
TableSortIconArrowDown.displayName = 'TableSortIconArrowDown';
var TableSortIconArrowUp = /*#__PURE__*/(0, _styledComponents.default)(_index.IconArrowUp).withConfig({
  displayName: "TableSortIconArrowUp",
  componentId: "c11n-8-101-0__sc-1lrs09d-1"
})([""]);
exports.TableSortIconArrowUp = TableSortIconArrowUp;
TableSortIconArrowUp.displayName = 'TableSortIconArrowUp';
var TableSortIconSort = /*#__PURE__*/(0, _styledComponents.default)(_index.IconSort).withConfig({
  displayName: "TableSortIconSort",
  componentId: "c11n-8-101-0__sc-1lrs09d-2"
})([""]);
exports.TableSortIconSort = TableSortIconSort;
TableSortIconSort.displayName = 'TableSortIconSort';

/** @component */